import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CloseIcon, ErrorSummaryIcon } from './Styles/Icons';
import { Dialog, FlexRow, DialogTitle, DialogContent, CircularButton, ButtonGroup, ButtonWithLoader } from './Styles/ErrorLogs';

class ErrorLogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			downloadingLogs: false,
			clearingLogs: false,
		};
	}

	clearLogsHandler = async () => {
		this.setState({ clearingLogs: true });
		await this.props.clearLogs();
		this.setState({ clearingLogs: false });
	};

	downloadLogsHandler = async () => {
		this.setState({ downloadingLogs: true });
		await this.props.downloadLogs();
		this.setState({ downloadingLogs: false });
	};

	render() {
		const { open } = this.props;
		const { downloadingLogs, clearingLogs } = this.state;

		return (
			<Dialog
				open={open || false}
				disableBackdropClick={true}
				maxWidth='sm'
				fullWidth
			>
				<DialogTitle>
					Errors Found
					<ButtonGroup alignRight>
						<CircularButton
							error
							outline
							disabled={clearingLogs || downloadingLogs}
							onClick={() => {
								this.props.onClose();
							}}
						>
							<CloseIcon />
						</CircularButton>
					</ButtonGroup>
				</DialogTitle>

				<DialogContent>
					<FlexRow style={{ padding: '1.2rem 0', justifyContent: 'center' }}>
						<ErrorSummaryIcon />
					</FlexRow>

					<FlexRow style={{ padding: '1rem 3rem', justifyContent: 'center', fontWeight: 'bold' }}>Error Summary</FlexRow>

					<FlexRow style={{ justifyContent: 'center' }}>Download the error report and clear error logs to proceed forward.</FlexRow>

					<FlexRow style={{ padding: '2rem 1rem 1rem 1rem' }}>
						<ButtonGroup alignCenter>
							<ButtonWithLoader
								secondary
								loading={downloadingLogs}
								onClick={() => this.downloadLogsHandler()}
							>
								Download Report
							</ButtonWithLoader>
							<ButtonWithLoader
								error
								loading={clearingLogs}
								onClick={() => this.clearLogsHandler()}
							>
								Clear
							</ButtonWithLoader>
						</ButtonGroup>
					</FlexRow>
				</DialogContent>
			</Dialog>
		);
	}
}

const mapStateToProps = (state) => ({
	session: state.session,
});

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(ErrorLogs);
